import { useCallback } from 'react';

import type { GlobalShortcutsItem } from '@atlassian/global-shortcuts';

import type { NavItemConfigInternal } from '../../../common/types';
import { useUserMenuDataShapes } from '../../user-state/user-menu-data-shapes-provider';
import { useItemsAndShortcuts } from '../index';

export function useItemProperties() {
	const { allItems, shortcuts } = useItemsAndShortcuts();
	const { userMenuData, visibleMenuIds } = useUserMenuDataShapes();

	const getItemProperties = useCallback(
		(itemMenuId: string) => {
			const item: NavItemConfigInternal | GlobalShortcutsItem =
				allItems?.[itemMenuId] || shortcuts?.[itemMenuId];
			if (!item) {
				return null;
			}

			return {
				index: userMenuData.findIndex((item) => item.menuId === itemMenuId) ?? -1,
				isReorderable: item?.isReorderable ?? true,
				isHideable: item?.isHideable ?? true,
				isVisible: visibleMenuIds.includes(itemMenuId),
			};
		},
		[allItems, shortcuts, userMenuData, visibleMenuIds],
	);

	return {
		getItemProperties,
	};
}
